'use client'

import { ModuleTag } from 'inspirationals/types/modules'
import { type ReactNode } from 'react'
import { useResponsiveBehavior } from 'responsive/hooks/useResponsiveBehavior/useResponsiveBehavior'

import { ModuleLayout } from '../shared/ModuleLayout/ModuleLayout'

import styles from './M3.module.scss'

type Props = {
	children: ReactNode
}

export function M3({ children }: Props) {
	const defaultImageSizes = useResponsiveBehavior({
		default: {
			regular: [{ size: 'calc((954px - 32px) / 3)' }],
		},
		medium: {
			regular: [{ size: 'calc(50vw - 16px)' }],
		},
		small: {
			regular: [{ size: 'calc(50vw - 16px)' }],
		},
	})

	return (
		<ModuleLayout
			className={styles.slot}
			defaultImageSizes={defaultImageSizes}
			moduleTag={ModuleTag.M3}
		>
			{children}
		</ModuleLayout>
	)
}
